import React, { Component } from 'react';

class Payment extends Component {
    render() {
        return (
            <p>Aquí se renderiza la vista del pago</p>
        );
    }
}

export default Payment;